/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_DescriptionInputs */

const cs_chat_description = /** @type {(inputs: Chat_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pište kolegům napříč pobočkami a sdílejte záznamy z CRM.`)
};

const en_chat_description = /** @type {(inputs: Chat_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message colleagues across offices and share CRM records.`)
};

/**
* | output |
* | --- |
* | "Message colleagues across offices and share CRM records." |
*
* @param {Chat_DescriptionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_description = /** @type {((inputs?: Chat_DescriptionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_DescriptionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_description(inputs)
	return cs_chat_description(inputs)
});